import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (e) {
            const detail = e.response?.data?.detail;
            setErr(typeof detail === "string" ? detail : "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[var(--st-cream)]">
            <form onSubmit={submit} className="w-full max-w-md p-10 bg-white/40 backdrop-blur border border-[var(--st-line)]">
                <p className="eyebrow text-[var(--st-gold-deep)] mb-3">Studio access</p>
                <h1 className="font-serif text-5xl mb-8">Sign in.</h1>
                <label className="eyebrow block mb-1">Email</label>
                <input
                    data-testid="admin-login-email"
                    required
                    type="email"
                    className="st-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="sugandhi@thesilver-tree.com"
                />
                <label className="eyebrow block mb-1 mt-6">Password</label>
                <input
                    data-testid="admin-login-password"
                    required
                    type="password"
                    className="st-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                />
                {err && <p className="text-red-700 text-sm mt-4" data-testid="admin-login-error">{err}</p>}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-submit"
                    className="btn-primary mt-8 w-full justify-center disabled:opacity-60"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>
        </main>
    );
};

export default AdminLogin;
